import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { Item } from "~/common/utils/types/sideBarTypes";

interface SideBarItemProps {
  selected?: boolean;
  children?: ReactNode;
  className?: string;
  Icon?: Item["Icon"];
  onClick?: () => void;
  inline?: boolean;
}

const SideBarItem = ({
  children,
  className,
  Icon,
  selected,
  onClick,
  inline,
}: SideBarItemProps) => (
  <button
    onClick={onClick}
    className={twMerge(
      "group flex w-full flex-col items-center gap-1 border-transparent p-2 text-center text-xs font-semibold text-[#525D6A] transition-all duration-300 ease-in-out",
      selected && "text-primary-600 hover:text-primary-600",
      inline && "flex-row gap-2",
      className,
    )}
  >
    {Icon && (
      <div
        className={twMerge(
          "rounded-lg p-3 transition-all duration-300 ease-in-out group-hover:bg-primary-100",
          selected && "bg-primary-100",
        )}
      >
        <Icon
          className={twMerge("size-6 stroke-2", selected && "text-primary-600")}
        />
      </div>
    )}
    {children}
  </button>
);

export default SideBarItem;
